export { default } from './NotificationTables';



// WEBPACK FOOTER //
// ./src/Admin/NotificationTables/index.js